export default {
  title: 'AI-forslag',
  subtitle: 'Forslag fra FoodAmigos-agenten til dine restauranter.',
  empty: 'Intet at vise her.',
  tabs: {
    pending: 'Afventer',
    history: 'Historik',
  },
  table: {
    id: 'ID',
    company: 'Restaurant',
    type: 'Type',
    summary: 'Forslag',
    created_at: 'Oprettet',
    status: 'Status',
    actions: 'Handlinger',
  },
  statuses: {
    pending: 'Afventer',
    confirmed: 'Bekræftet',
    applied: 'Anvendt',
    rejected: 'Afvist',
    failed: 'Mislykkedes',
    expired: 'Udløbet',
  },
  types: {
    'smart_pricing.global_reduce': 'Rabat på hele menuen',
    'smart_pricing.category_reduce': 'Kategorirabat',
    'competitor_listing.confirm': 'Bekræft markedspladsopførsel',
    'catalog.price_correct': 'Prisrettelse',
    'catalog.add_item': 'Tilføj manglende vare',
    'catalog.quality': 'Indholdskvalitet',
    'catalog.reorder': 'Omrokering af menu',
  },
  actions: {
    review: 'Gennemse',
    confirm: 'Bekræft',
    reject: 'Afvis',
    cancel: 'Annuller',
    edit: 'Rediger',
  },
  edit: {
    label: 'Beskriv den ændring, du ønsker (der genereres en ny revision)',
    placeholder: 'Beskriv den ønskede ændring',
    placeholders: {
      'smart_pricing.global_reduce':
        'f.eks. gør den til 15 %, omdøb den til „Sommer -15 %“, eller kør den kun på levering',
      'smart_pricing.category_reduce': 'f.eks. sæt rabatten på Drikkevarer til 10 % og fjern afhentning',
      'catalog.price_correct': 'f.eks. fjern rettelsen for „Cola“, eller sæt „Pizza“ til 7,50 €',
      'catalog.add_item': 'f.eks. fjern varen „Vand“, eller sæt prisen på „Falafel Wrap“ til 6,50 €',
      'catalog.quality': 'f.eks. fjern varerne „Pommes frites“ og „Cola“ fra listen',
      'catalog.reorder': 'f.eks. sæt Drikkevarer sidst og flyt bestselleren øverst i Bowls',
      'competitor_listing.confirm': 'f.eks. erstat Uber Eats-linket med https://…, eller tilføj Wolt: https://…',
    },
    submit: 'Generer revision',
  },
  revisions: {
    label: 'Revision',
    original: 'Original',
    revision_n: 'Revision {{n}}',
  },
  detail: {
    title: 'Forslagsdetaljer',
    targets: 'Berørte varer',
    evidence: 'Hvorfor agenten foreslår dette',
    no_targets: 'Ingen varedetaljer angivet.',
    composed_from: 'Sammensat af',
    items_suffix: 'varer',
    nutrition: 'Næringsindhold',
    uncategorized: 'Uden kategori',
    decided_by: 'Afgjort af',
    decision_note: 'Note',
    category_existing: 'eksisterende',
    category_new: 'ny',
    product: 'Produkt',
    price_change: 'Prisændring',
    no_items: 'Ingen varer',
    fills_image: '+ billede',
    fills_description: '+ beskrivelse',
    fills_nutrition: '+ næringsindhold',
    fills_modifiers: '+ tilvalg',
    competitor_links: 'Konkurrentlinks',
    no_competitor_links: 'Ingen fundne konkurrentlinks endnu.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Afvis dette forslag',
    note_label: 'Årsag',
    note_placeholder: 'Forklar kort, hvorfor du afviser dette forslag',
  },
  toasts: {
    load_failed: 'Forslag kunne ikke indlæses',
    confirmed: 'Forslag bekræftet',
    rejected: 'Forslag afvist',
    action_failed: 'Handlingen kunne ikke gennemføres',
    revision_created: 'Ny revision genereret',
    revision_failed: 'Der kunne ikke genereres en revision ud fra den instruktion',
    choose_revision: 'Dette forslag har flere revisioner – åbn det, og vælg en at bekræfte',
  },
};
